
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/automotive-software/queue-for-you-software",
      function () {
        return require("private-next-pages/automotive-software/queue-for-you-software.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/automotive-software/queue-for-you-software"])
      });
    }
  